import * as React from "react";

export const LevelSix = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={44}
    height={44}
    fill="none"
    {...props}
  >
    <circle cx={22} cy={22} r={22} fill="#169FED" />
    <path
      fill="#fff"
      d="M34.813 22.28c0 6.922-5.61 12.533-12.532 12.533S9.748 29.202 9.748 22.28c0-6.921 5.611-12.532 12.533-12.532 6.921 0 12.532 5.61 12.532 12.532Zm-22.254 0c0 5.37 4.352 9.722 9.722 9.722 5.369 0 9.722-4.353 9.722-9.722 0-5.37-4.353-9.722-9.722-9.722-5.37 0-9.722 4.353-9.722 9.722Z"
    />
  </svg>
);
